export const config = {
    homepage: {
        refreshWidgetDataIntervalMillis: 7000
    },
    widgets: {
        max: 50,
        directValue: {
            preview: {
                defaultFontColor: "inherit",
                defaultBackgroundColor: "#eaeaea",
            },
            defaultFontColor: "#6F7172",
            defaultBackgroundColor: "#eaeaea",
            simpleColorPicker: {
                fontColor: ["#FFFFFF", "#676A6C"],
                size: "97px"
            },
            complexColorPicker: {
                size: 100,
                disableAlpha: true
            }
        },
        stickyNote: {
            textMaxLength: 10000
        }
    },
    widgetsGroups: [{
        id: "INTERFACES",
        widgets: [
            "DIRECT_VALUE",
            "CONTROLLER"
        ]
    }, {
        id: "DATA",
        widgets: [
            "COMPLEX_CHART"
        ]
    }, {
        id: "OTHERS",
        widgets: [
            "STICKY_NOTE",
           /*  "IFRAME", */
            "TITLE"
        ]
    }
    ],
    widgetsConfigs: {
        DIRECT_VALUE: [{
            configTypes: [{
                required: false,
                name: "widgetDisplayName"
            }]
        }, {
            configTypes: [{
                required: true,
                name: "interfaceSelector",
                excludeInterfaceType: "OUT",
            }]
        }],
        STICKY_NOTE: [{
            configTypes: [{
                name: "widgetDisplayName",
                required: true
            }, {
                name: "text",
                required: true
            }]
        }],
        CONTROLLER: [{
            configTypes: [{
                name: "widgetDisplayName",
                required: true
            }]
        }, {
            configTypes: [{
                name: "interfaceSelector",
                excludeInterfaceType: "IN",
                required: true,
            }]
        }],
        IFRAME: [{
            configTypes: [{
                name: "widgetDisplayName",
                required: true
            }, {
                name: "widgetUrl",
                required: true
            }]
        }],
        COMPLEX_CHART: [{
            configTypes: [{
                name: "widgetDisplayName",
                required: true
            }, {
                name: "chartSeriesSelector",
                required: true
            }]
        }],
        TITLE: [{
            configTypes: [{
                name: "widgetDisplayName",
                required: true
            },{
                name: "checkbox",
                checkboxId: 2,
                labels: ["left", "center", "right"],
                maxChecked: 1,
                title: "titlePosition",
                required: true
            }],
        },{
            configTypes: [{
                    name: "checkbox",
                    checkboxId: 1,
                    labels: ["hasSeparator"],
                    maxChecked: 1,
                }]
        }]
    },
};